import type { ReactNode } from "react";

export type PillTone = "neutral" | "ok" | "warn" | "danger" | "brand" | "info";

interface PillProps {
  tone?: PillTone;
  pulse?: boolean;
  children: ReactNode;
  title?: string;
}

export function Pill({ tone = "neutral", pulse, children, title }: PillProps) {
  const cls = [
    "pill",
    tone !== "neutral" ? `pill--${tone}` : "",
    pulse ? "pill--pulse" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} title={title}>
      <span className="pill__dot" aria-hidden="true" />
      {children}
    </span>
  );
}
